import { render, staticRenderFns } from "./RemoveReport.vue?vue&type=template&id=506b5f4c&"
import script from "./RemoveReport.vue?vue&type=script&lang=js&"
export * from "./RemoveReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports